import { makeStyles } from '@material-ui/core/styles';
import { getTokens } from '../../../styles/tokens';

export default makeStyles(theme => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    listItem: {
      padding: theme.spacing(1, 0)
    },
    total: {
      fontWeight: '700'
    },
    // resumo do pedido: dois blocos lado a lado num cartão
    summary: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      backgroundColor: t.paper,
      boxShadow: t.shadow.card,
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: { gridTemplateColumns: 'minmax(0, 1fr)' }
    },
    block: {
      minWidth: 0,
      padding: '14px 18px 16px',
      '& + &': {
        borderLeft: `1px solid ${t.line}`,
        [theme.breakpoints.down('xs')]: { borderLeft: 0, borderTop: `1px solid ${t.line}` }
      }
    },
    title: {
      margin: '0 0 8px',
      fontFamily: t.font,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: t.textSecondary
    },
    rows: { margin: 0 },
    row: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 12,
      padding: '5px 0',
      fontFamily: t.font,
      fontSize: 14
    },
    term: { flex: 'none', color: t.textSecondary },
    value: {
      margin: 0,
      minWidth: 0,
      textAlign: 'right',
      color: t.text,
      fontVariantNumeric: 'tabular-nums',
      overflowWrap: 'anywhere'
    },
    totalRow: {
      marginTop: 6,
      paddingTop: 10,
      borderTop: `1px solid ${t.lineRow}`,
      '& dt': { color: t.text, fontWeight: 600 },
      '& dd': { fontSize: 17, fontWeight: 700 }
    }
  };
});
